'use es6';

import { Alert } from 'foundations-components/transitional/components/Alert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { DISABLE_CUSTOM_JITA_UI } from 'page-editor-ui/redux/selectors/testFlagSelectors';
import { setTemporaryTestFlag } from 'ContentEditorUI/lib/testFlags';

// Add `#testFlags=disableCustomJitaUI` to temporarily disable the custom JITA UI and see what
// a customer would see
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const disableCustomJitaUIViaTestFlag = () => {
  setTemporaryTestFlag(DISABLE_CUSTOM_JITA_UI);
};
const JitadAndCantSaveWarning = () => /*#__PURE__*/_jsx(Alert, {
  type: "warning",
  children: /*#__PURE__*/_jsxs(ButtonWrapper, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: `jitadAndCantSaveWarning.title`
    }), /*#__PURE__*/_jsx(Tooltip, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `jitadAndCantSaveWarning.tooltipAndMakeReadOnly`
      }),
      children: /*#__PURE__*/_jsx(Button, {
        size: "extra-small",
        use: "tertiary-light",
        onClick: disableCustomJitaUIViaTestFlag,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `jitadAndCantSaveWarning.disableCustomJitaUIButton`
        })
      })
    })]
  })
});
export default JitadAndCantSaveWarning;